import Dbm from "dbm";

export default class Timer extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        this.item.requireProperty("time", 0);
        this.item.requireProperty("lastTime", 0);
        this.item.requireProperty("startTime", 0);
        this.item.requireProperty("startAt", performance.now());
    }

    get time() {
        return this.item.time;
    }

    get delta() {
        return this.item.time-this.item.lastTime;
    }

    restart() {
        this.item.time = 0;
        this.item.lastTime = 0;
        this.item.startTime = 0;
        this.item.startAt = performance.now();
    }

    start() {
        this.item.startTime = this.item.time;
        this.item.startAt = performance.now();
    }

    update() {
        let newTime = performance.now();
        this.item.lastTime = this.item.time;
        this.item.time = (newTime-this.item.startAt)/1000+this.item.startTime;
    }
}